/* eslint-disable no-console */
import { defineStore } from 'pinia';
//import { createClient } from '@supabase/supabase-js';
import { supabase } from '@/supabase';
import { fetchWithAuth } from '@/utils/fetchWithAuth';


const SUPABASE_URL = "https://rwnbpxpxauytxfuuffsg.supabase.co";
// const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJ3bmJweHB4YXV5dHhmdXVmZnNnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDc2NjgxNzAsImV4cCI6MjAyMzI0NDE3MH0.5RONagHEOOFdYgEx7x0lpcSa3xz-2MY5K3fAjD3GP-E";
// Create a Supabase client instance for storage
// const supabaseStorageClient = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

// Generate a UUID (RFC4122 v4 compliant)
function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

export const useMainStore = defineStore('main', {
  state: () => ({
    _hasBootstrapped: false,            // <-- NEU: merken, ob Erst-Ladevorgang fertig ist
    showAddCompetitorModal: false,
    showFullViewModal: false,
    fullViewImageSrc: "",
    contentBlocks: [],
    isLoading: false,
    allDataLoaded: false,
    isAddCompetitorModalOpen: false,
    dataOffset: 0,
    dataLimit: 20,
    dataList: [],
    dataList2: [],
    sidebarItems: [],
    // NEW state for planned campaigns
    plannedCampaigns: [],

        /* Step-3: tenant-hidden sets */
        hiddenKanalIds  : new Set(),      // bigint[]
        hiddenPlannedIds: new Set(),      // bigint[]
  }),

  // ───────────────────────────── getters (optional) ───────────────────────
  getters : {
    /** True if the campaign/event is hidden for the caller’s tenant. */
    isEventHidden : (state) => (event) =>
      (event.kanalid != null)
        ? state.hiddenKanalIds.has(event.kanalid)
        : state.hiddenPlannedIds.has(event.id),
  },

  actions: {

    /**
+   * Setzt lokale Caches zurück und ruft sämtliche
+   * Ladefunktionen erneut auf.
+   * Wird nach erfolgreichem join_tenant() oder
+   * nach Login benutzt.
+   */
  async reloadData() {
    await this.fetchHiddenSets();
    this.dataOffset    = 0;
    this.allDataLoaded = false;
    this.contentBlocks = [];
    this.sidebarItems  = [];
    this.dataList      = [];
    this.dataList2     = [];

    await Promise.all([
      this.fetchSidebarItems(),      // Wettbewerber
      this.fetchWithAbbreviations(), // Kanal-Daten (RPC)
      this.fetchData(),              // Kanal-Feed
      this.fetchPlannedCampaigns(),  // Planner
    ]);
},

    openAddCompetitorModal() {
      this.isAddCompetitorModalOpen = true;
    },
    closeAddCompetitorModal() {
      this.isAddCompetitorModalOpen = false;
    },
    openFullView(imageSrc) {
      this.fullViewImageSrc = imageSrc;
      this.showFullViewModal = true;
    },
    closeFullView() {
      this.showFullViewModal = false;
    },
    /**
     * Uploads a screenshot file to the "screenshots" bucket and calls an edge function
     * to update the appropriate table record. The filename is generated as a UUID with
     * the original file extension. For kanal_composed, the edge function URL now
     * includes query parameters (kanalid and filename) instead of using a JSON body.
     */
    async uploadScreenshot(event, file) {
      // 1) upload to storage bucket
      const ext = file.name.split('.').pop().toLowerCase();
      const filename = `${generateUUID()}.${['png','jpg','jpeg'].includes(ext) ? ext : 'png'}`;
      const { error: uploadError } = await supabase
        .storage
        .from('screenshots')
        .upload(filename, file, { upsert: false });   // keep ESLint happy, be explicit
      if (uploadError) throw uploadError;

      const publicURL = `${SUPABASE_URL}/storage/v1/object/public/screenshots/${filename}`;

      // 2) call edge fn (GET or POST both supported)
      const params = event.kanalid != null
        ? `kanalid=${encodeURIComponent(event.kanalid)}&filename=${encodeURIComponent(filename)}`
        : `id=${encodeURIComponent(event.id)}&filename=${encodeURIComponent(filename)}`;

      const fn = event.kanalid != null
        ? 'update_kanal_screenshot'
        : 'update_planned_screenshot';

      const res = await fetchWithAuth(
        `${SUPABASE_URL}/functions/v1/${fn}?${params}`,
        { method: 'GET' }
      );
      const body = await res.json();
      if (!res.ok) throw new Error(body.error || 'Edge function failed');

      // 3) update local modal state
      event.dbImages = event.dbImages || [];
      event.dbImages.push(publicURL);

      return publicURL;
    },
    
    // dead
    async updateScreenshotLink(aktionKey, screenshotNumber, url) {
      const columnName = `screenshotlink${screenshotNumber}`;
      const response = await fetchWithAuth(
        `${SUPABASE_URL}/rest/v1/kanal_composed?aktion_key=eq.${encodeURIComponent(aktionKey)}`,
        {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ [columnName]: url }),
        }
      );
      const data = await response.json();
      return data;
    },

    async fetchData() {
      if (this.isLoading || this.allDataLoaded) return;
      this.isLoading = true;
      try {
        const response = await fetchWithAuth(
          `${SUPABASE_URL}/functions/v1/edge-competify/kanal/all`
        );
        const jsonData = await response.json();
        const kanalData = jsonData.kanal;
        if (kanalData && kanalData.length > 0) {
          // Sort by 'datum_mail' descending
          kanalData.sort((a, b) => new Date(b.datum_mail) - new Date(a.datum_mail));
          this.dataList = kanalData;
          this.loadMoreData();
          console.log(jsonData);
        } else {
          this.allDataLoaded = true;
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
      this.isLoading = false;
    },

    getAktionsTypImage(item) {
      if (!item.aktions_typ) {
        return require('@/assets/images/default.jpg');
      }
      const aktionsType = item.aktions_typ.toLowerCase();
      if (aktionsType === 'aktion' || aktionsType === 'campaign') {
        return require('@/assets/images/campaign.png');
      } else if (aktionsType === 'sale') {
        return require('@/assets/images/sale.png');
      } else if (aktionsType === 'special') {
        return require('@/assets/images/special.png');
      }
      return require('@/assets/images/default.jpg');
    },

    loadMoreData() {
      if (this.dataOffset >= this.dataList.length) {
        this.allDataLoaded = true;
        return;
      }
      const nextItems = this.dataList.slice(this.dataOffset, this.dataOffset + this.dataLimit);
      const newContentBlocks = nextItems.map(item => {
        let images = [];
        const validTypes = ['aktion', 'campaign', 'sale', 'special'];
        if (item.aktions_typ && validTypes.includes(item.aktions_typ.toLowerCase())) {
          images.push({
            src: this.getAktionsTypImage(item),
            error: false,
            fallback: this.getAktionsTypImage(item),
          });
        } else {
          // Use the updated getImagesFromItem() for non-standard items
          images = this.getImagesFromItem(item).map(img => ({
            src: img,
            error: false,
            fallback: require('@/assets/images/default.jpg'),
          }));
        }
        return {
          category: item.name ? item.name.toLowerCase().replace(/\s/g, '') : 'unknown',
          companyName: item.name || 'Unknown Company',
          initials: item.name ? item.name.match(/\b\w/g).join('') : 'UC',
          logoBgColor: 'bg-gray-400',
          logoTextColor: 'text-gray-900',
          title: item.aktion_compose_name || item.betreff || 'No Title',
          incent: item.incentivierung,
          reference: item.betreff,
          date: item.datum_mail,
          collection: item.sortiment_kategorie,
          images,
          tags: this.getTagsFromItem(item),
          aktionKey: item.aktion_key,
        };
      });
      this.contentBlocks.push(...newContentBlocks);
      this.dataOffset += this.dataLimit;
      if (this.dataOffset >= this.dataList.length) {
        this.allDataLoaded = true;
      }
    },
    // Updated getImagesFromItem: now supports multiple comma-separated filenames
    // For planned_campaigns, use the "screenshot" column.

    getImagesFromItem(item) {
      const images = [];
    
      if (item.screenshot) {
        images.push(
          ...item.screenshot
            .split(',')
            .map((filename) => this.getImageUrl(filename.trim()))
            .filter(Boolean)
        );
      }
    
      // ✂️  DO NOT read screenshotlink2 any more
      //     images from kanal_composed are resolved on demand for the
      //     *current* tenant and stored in event.dbImages instead.
    
      return images;
    },


    /* For kanal_composed, use "screenshotlink2" exclusively.
    getImagesFromItem(item) {
      const images = [];
      if (item.screenshot) {
        images.push(
          ...item.screenshot
            .split(',')
            .map(filename => this.getImageUrl(filename.trim()))
            .filter(Boolean)
        );
      } else if (item.screenshotlink2) {
        images.push(
          ...item.screenshotlink2
            .split(',')
            .map(filename => this.getImageUrl(filename.trim()))
            .filter(Boolean)
        );
      }
      return images;
    },
    */
    getImageUrl(screenshotLink) {
      return `${SUPABASE_URL}/storage/v1/object/public/screenshots/${screenshotLink}`;
    },
    getTagsFromItem(item) {
      const tags = [];
      if (item.kanalart === 'E-Mail') tags.push('Newsletter');
      if (item.kanalart === 'Website') tags.push('Website');
      if (item.aktions_typ === 'Aktion') tags.push('Aktion');
      if (item.aktions_typ === 'Sale') tags.push('Sale');
      if (item.aktions_typ === 'Special') tags.push('Benefit');
      return tags;
    },
    async fetchSidebarItems() {
      try {
        const response = await fetchWithAuth(
          `${SUPABASE_URL}/functions/v1/edge-competify/wettbewerber/all`
        );
        const data = await response.json();
        this.sidebarItems = data.wettbewerber;
        this.sidebarItems.forEach(item => {
          item.backgroundColor = item.backgroundColor || this.getRandomColor();
          item.textColor = item.textColor || 'text-gray-900';
          item.abbreviation = item.abbrevation ? item.abbrevation.toUpperCase() : 'N/A';
        });
      } catch (error) {
        console.error('Error fetching sidebar items:', error);
      }
    },
    async fetchWithAbbreviations() {
      if (this.isLoading || this.allDataLoaded) return;
      this.isLoading = true;
      try {
        const response = await fetchWithAuth(
          `${SUPABASE_URL}/functions/v1/edge-competify/kanal/with-abbreviation`
        );
        const jsonData = await response.json();
        if (jsonData.data && jsonData.data.length > 0) {
          this.dataList2 = jsonData.data.map(item => ({
            ...item,
            abbreviation: item.abbrevation ? item.abbrevation.toUpperCase() : 'N/A',
            colorClass: this.getRandomColor(),
          }));
          console.log('DataList after fetch:', this.dataList2);
        } else {
          this.allDataLoaded = true;
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
      this.isLoading = false;
    },
    getRandomColor() {
      const colors = [
        'bg-red-400',
        'bg-blue-400',
        'bg-green-400',
        'bg-yellow-400',
        'bg-purple-400',
        'bg-pink-400',
        'bg-indigo-400',
        'bg-teal-400',
        'bg-orange-400',
      ];
      return colors[Math.floor(Math.random() * colors.length)];
    },
    async fetchFlag(aktionKey) {
      try {
        const url = `${SUPABASE_URL}/functions/v1/flagEdge/flag?aktion_key=${encodeURIComponent(aktionKey)}`;
        const response = await fetchWithAuth(url);
        const data = await response.json();
        return data;
      } catch (error) {
        console.error('Error fetching flag:', error);
        return { flagged: false };
      }
    },
    async setFlag(aktionKey, flagged) {
      try {
        const url = `${SUPABASE_URL}/functions/v1/flagEdge/flag`;
        const body = { aktion_key: aktionKey, flagged };
        const response = await fetchWithAuth(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        });
        const data = await response.json();
        return data;
      } catch (error) {
        console.error('Error setting flag:', error);
        throw error;
      }
    },
    async removeFlag(aktionKey) {
      try {
        const url = `${SUPABASE_URL}/functions/v1/flagEdge/flag`;
        const response = await fetchWithAuth(url, {
          method: 'DELETE',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ aktion_key: aktionKey }),
        });
        const data = await response.json();
        return data;
      } catch (error) {
        console.error('Error removing flag:', error);
        throw error;
      }
    },
    async updateEventFlag(aktionKey, flagged) {
      try {
        if (flagged) {
          return await this.setFlag(aktionKey, flagged);
        } else {
          return await this.removeFlag(aktionKey);
        }
      } catch (error) {
        console.error('Error updating event flag:', error);
        throw error;
      }
    },
    async submitEventFeedback(aktionKey, flagged, messageObj) {
      try {
        return await this.createMessage(aktionKey, messageObj.text);
      } catch (error) {
        console.error('Error submitting event feedback:', error);
        throw error;
      }
    },
    async fetchMessages(aktionKey) {
      try {
        const url = `${SUPABASE_URL}/functions/v1/messagesEdge/messages?aktion_key=${encodeURIComponent(aktionKey)}`;
        const response = await fetchWithAuth(url);
        const data = await response.json();
        return data.messages || [];
      } catch (error) {
        console.error('Error fetching messages:', error);
        return [];
      }
    },
    async createMessage(aktionKey, text) {
      try {
        const url = `${SUPABASE_URL}/functions/v1/messagesEdge/messages`;
        const body = { aktion_key: aktionKey, message: text };
        const response = await fetchWithAuth(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        });
        const data = await response.json();
        return data.inserted || [];
      } catch (error) {
        console.error('Error creating message:', error);
        throw error;
      }
    },
    async deleteMessage(id) {
      try {
        const url = `${SUPABASE_URL}/functions/v1/messagesEdge/messages`;
        const body = { id };
        const response = await fetchWithAuth(url, {
          method: 'DELETE',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        });
        const data = await response.json();
        return data.deleted || [];
      } catch (error) {
        console.error('Error deleting message:', error);
        throw error;
      }
    },
    
    
    async fetchPlannedCampaigns() {
      try {
        const res = await fetchWithAuth(
          `${SUPABASE_URL}/functions/v1/campaignPlanning`
        );
        const { campaigns } = await res.json();
        this.plannedCampaigns = (campaigns || []).map(c => ({
          id: c.id,
          fromDate: c.von,
          toDate:   c.bis,
          type:     c.aktions_typ,
          incent:   c.incentivierung,
          competitorId: c.competitor_id,
          // screenshots now live in planned_screenshots table
          dbImages: []
        }));
        return this.plannedCampaigns;
      } catch (e) {
        console.error('Error fetching planner:', e);
        return [];
      }
    },
    async createPlannedCampaign(campaign) {
      try {
        const payload = {
          von: campaign.fromDate,
          bis: campaign.toDate,
          aktions_typ: campaign.type,
          incentivierung: campaign.incent,
          competitor_id: campaign.competitorId || null,
        };
  
        const response = await fetchWithAuth(
          `${SUPABASE_URL}/functions/v1/campaignPlanning`,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          }
        );
        const data = await response.json();
        const newCampaign = {
          id: data.campaign.id,
          fromDate: data.campaign.von,
          toDate: data.campaign.bis,
          type: data.campaign.aktions_typ,
          incent: data.campaign.incentivierung,
          competitorId: data.campaign.competitor_id,
          screenshot: data.campaign.screenshot || ""
        };
        this.plannedCampaigns.push(newCampaign);
        return newCampaign;
      } catch (error) {
        console.error('Error creating planned campaign:', error);
        throw error;
      }
    },
    async updatePlannedCampaign(campaign) {
      try {
        const payload = {
          von: campaign.fromDate,
          bis: campaign.toDate,
          aktions_typ: campaign.type,
          incentivierung: campaign.incent,
          competitor_id: campaign.competitorId || null,
        };
  
        const response = await fetchWithAuth(
          `${SUPABASE_URL}/functions/v1/campaignPlanning/${campaign.id}`,
          {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          }
        );
        const data = await response.json();
        const updatedCampaign = {
          id: data.campaign.id,
          fromDate: data.campaign.von,
          toDate: data.campaign.bis,
          type: data.campaign.aktions_typ,
          incent: data.campaign.incentivierung,
          competitorId: data.campaign.competitor_id,
          screenshot: data.campaign.screenshot || ""
        };
        const index = this.plannedCampaigns.findIndex(c => c.id === updatedCampaign.id);
        if (index !== -1) {
          this.plannedCampaigns[index] = updatedCampaign;
        }
        return updatedCampaign;
      } catch (error) {
        console.error('Error updating planned campaign:', error);
        throw error;
      }
    },
    async deletePlannedCampaign(id) {
      try {
        const response = await fetchWithAuth(
          `${SUPABASE_URL}/functions/v1/campaignPlanning/${id}`,
          {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
          }
        );
        const data = await response.json();
        this.plannedCampaigns = this.plannedCampaigns.filter(c => c.id !== id);
        return data;
      } catch (error) {
        console.error('Error deleting planned campaign:', error);
        throw error;
      }
    },
    // NEW: Delete screenshot action (for both kanal_composed and planned_campaigns)
    async deleteScreenshot(event, imgUrl) {
      const filename = imgUrl.split('/').pop();
      const params = event.kanalid != null
        ? `kanalid=${encodeURIComponent(event.kanalid)}&filename=${encodeURIComponent(filename)}`
        : `id=${encodeURIComponent(event.id)}&filename=${encodeURIComponent(filename)}`;

      const fn = event.kanalid != null
        ? 'update_kanal_screenshot'
        : 'update_planned_screenshot';

      const res = await fetchWithAuth(
        `${SUPABASE_URL}/functions/v1/${fn}?${params}`,
        { method: 'DELETE' }
      );
      const body = await res.json();
      if (!res.ok) throw new Error(body.error || 'Edge delete failed');

      // remove from local array
      event.dbImages = (event.dbImages || [])
        .filter(url => url.split('/').pop() !== filename);

      return body;
    },

      /**
     * Fetch all screenshots for one kanal_composed row.
     * Returns an array of filenames (e.g. ["a.png","b.jpg"]).
     */
// 1) kanal screenshots …
async fetchKanalScreenshots(kanalid) {
  const res = await fetchWithAuth(
    `${SUPABASE_URL}/functions/v1/update_kanal_screenshot?kanalid=${encodeURIComponent(kanalid)}`
  );
  const { filenames } = await res.json();
  return filenames || [];
},

// 2) planned screenshots …
async fetchPlannedScreenshots(id) {
  const res = await fetchWithAuth(
    `${SUPABASE_URL}/functions/v1/update_planned_screenshot?id=${encodeURIComponent(id)}`
  );
  const { filenames } = await res.json();
  return filenames || [];
},


    //  ── Tenant-hidden helpers (Step-3) ───────────────────────────────────
    /**
     * Download both hidden-ID sets for the current tenant.
     * Must be called **after** the user is authenticated.
     */
    async fetchHiddenSets () {
      try {
        // a) kanal_composed rows
        const res1          = await fetchWithAuth(`${SUPABASE_URL}/functions/v1/update_kanal_hidden`);
        const { kanalids }  = await res1.json();
        this.hiddenKanalIds = new Set(kanalids ?? []);

        // b) planned_campaigns rows
        const res2               = await fetchWithAuth(`${SUPABASE_URL}/functions/v1/update_planned_hidden`);
        const { campaign_ids }   = await res2.json();
        this.hiddenPlannedIds    = new Set(campaign_ids ?? []);
      } catch (err) {
        console.error('Error fetching hidden sets:', err);
      }
    },

    /**
     * Toggle the hidden-state of one event (kanal or planned) for this tenant.
     * The Edge function shares the “screenshot” signature: GET/POST = insert, DELETE = remove.
     */
    async toggleEventHidden (event) {
      const isHiddenNow = this.isEventHidden(event);
      const baseURL     = event.kanalid != null
        ? `${SUPABASE_URL}/functions/v1/update_kanal_hidden?kanalid=${encodeURIComponent(event.kanalid)}`
        : `${SUPABASE_URL}/functions/v1/update_planned_hidden?campaign_id=${encodeURIComponent(event.id)}`;

      const method = isHiddenNow ? 'DELETE' : 'POST';
      const resp    = await fetchWithAuth(baseURL, { method });

      if (!resp.ok) {
        const { error } = await resp.json();
        throw new Error(error ?? 'Toggle hidden failed');
      }

      // mutate local cache
      if (event.kanalid != null) {
        isHiddenNow ? this.hiddenKanalIds.delete(event.kanalid) : this.hiddenKanalIds.add(event.kanalid);
      } else {
        isHiddenNow ? this.hiddenPlannedIds.delete(event.id) : this.hiddenPlannedIds.add(event.id);
      }
    },

  },
});
